import configuracoesLista from "@/modules/Configuracoes/pages/Index";
import configuracoesNovo from "@/modules/Configuracoes/pages/Create";
import configuracoesEditar from "@/modules/Configuracoes/pages/Update";

export default [
  {
    name: "econfConfiguracoes",
    path: "/configuracoes/econf",
    component: () => import("@/modules/NFe/pages/EconfConfiguracoes.vue"),
    meta: { title: "Conciliação Financeira (ECONF)" },
  },
  {
    name: "configuracoesLista",
    path: "/configuracoes",
    component: configuracoesLista,
    meta: { title: "Ambiente" },
  },
  {
    name: "configuracoesNovo",
    path: "/configuracoes/novo",
    component: configuracoesNovo,
    meta: { title: "Ambiente" },
  },
  {
    name: "configuracoesEditar",
    path: "/configuracoes/:id/editar",
    component: configuracoesEditar,
    meta: { title: "Ambiente" },
  }
];
